var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgParentWelcomeModalImage2 = function SvgParentWelcomeModalImage2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 368 177"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 71,
    y: 18,
    fill: "#EF8006",
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 11,
    x: 13,
    y: 100,
    fill: "#EF8006",
    rx: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 168,
    height: 100,
    x: 200,
    y: 52,
    fill: "#EF8006",
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313A42",
    d: "M74 0h225a8 8 0 0 1 8 8v29H66V8a8 8 0 0 1 8-8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278,
    cy: 19,
    r: 11,
    fill: "#505A65"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFF",
    fontFamily: "OpenSans-Bold, Open Sans",
    fontSize: 10,
    fontWeight: "bold",
    letterSpacing: 0.714
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 86.83,
    y: 23
  }, "STUDENT MODE")), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M66 37h241v121a8 8 0 0 1-8 8H74a8 8 0 0 1-8-8z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24,
    x: 81,
    y: 76,
    fill: "#C0E0FD",
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    x: 233,
    y: 76,
    fill: "#C0E0FD",
    rx: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    x: 233,
    y: 96,
    fill: "#C0E0FD",
    rx: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 7,
    x: 254,
    y: 77,
    fill: "#C0E0FD",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 7,
    x: 114,
    y: 79,
    fill: "#C0E0FD",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 7,
    x: 98,
    y: 112,
    fill: "#C0E0FD",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 7,
    x: 98,
    y: 129,
    fill: "#C0E0FD",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 4,
    x: 99,
    y: 50,
    fill: "#C0E0FD",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 4,
    x: 137,
    y: 50,
    fill: "#C0E0FD",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 4,
    x: 176,
    y: 50,
    fill: "#C0E0FD",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 7,
    x: 254,
    y: 98,
    fill: "#C0E0FD",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 7,
    x: 254,
    y: 118,
    fill: "#C0E0FD",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 7,
    x: 254,
    y: 138,
    fill: "#C0E0FD",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    x: 83,
    y: 111,
    fill: "#C0E0FD",
    rx: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 7,
    x: 98,
    y: 146,
    fill: "#C0E0FD",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    x: 233,
    y: 116,
    fill: "#C0E0FD",
    rx: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    x: 233,
    y: 136,
    fill: "#C0E0FD",
    rx: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D6DBE0",
    d: "M66 65.5h241"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#366AFF",
    d: "M94 62h28v4H94z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 295.5,
    cy: 146.5,
    r: 30.5,
    fill: "#2256E5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m297.228 139.615 5.773 5.773-12.488 12.466-5.144.583a1.05 1.05 0 0 1-.876-.314 1.05 1.05 0 0 1-.314-.876l.584-5.143zm9.322-.853q.629.629.629 1.527a2.08 2.08 0 0 1-.63 1.527l-2.537 2.538-5.75-5.75 2.538-2.538a2.08 2.08 0 0 1 1.527-.629q.899 0 1.527.63z"
  }))));
};
export default SvgParentWelcomeModalImage2;